import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.handleRowClick.bind(this))
    this.setupTomSelectListeners()
  }

  setupTomSelectListeners() {
    const tomSelectElements = this.element.querySelectorAll('[data-controller="select"]')
    tomSelectElements.forEach(element => {
      setTimeout(() => {
        if (element.tomselect) {
          element.tomselect.on('change', (value) => {

            const editableCell = element.closest('[data-editable="true"]')
            if (editableCell) {
              this.handleTomSelectChange(element, value)
            }
          })
        }
      }, 100)
    })
  }

  handleTomSelectChange(element, value) {
    element.value = value
    const changeEvent = new Event('change', { bubbles: true })
    element.dispatchEvent(changeEvent)

    const form = element.closest('form')
    if (form) {
      form.submit()
    }
  }

  handleRowClick(event) {
    if (event.target.closest('.action-cell') || event.target.closest('[data-editable="true"]')) return

    const row = event.target.closest('.clickable-row')
    if (!row) return

    const showUrl = row.dataset.showUrl
    if (showUrl) {
      window.location.href = showUrl
    }
  }

  handleChange(event) {
    const input = event.target
    const form = input.closest('form')
    form.submit()
  }

  handleInputKeypress(event) {
    if (event.key === 'Enter') {
      const form = event.target.closest('form')
      form.submit()
    }
  }
}
